import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import SearchIcon from "@mui/icons-material/Search";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { alpha, styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  changeSearchTerm,
  changeUsedSearchTerm,
} from "../../services/currentInformation/actions";
import LocationDropdown from "./LocationDropdown";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    inputProps: { color: "white" },
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

function Header(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [searchQuery, setSearchQuery] = useState(props.searchTerm);
  const [productsFoundByQuery, setProductsFoundByQuery] = useState(
    props.usedSearchTerm
  );

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const whichTitle = () => {
    if (props.variableSupplierTitle) {
      if (props.businessLogin) {
        return "Onze leveranciers";
      } else if (props.farmerLogin) {
        return "Onze boeren";
      }
      return "Onze locals";
    }
    return props.title;
  };

  const handleChange = (event) => {
    if ((event.target.value == "") | (event.target.value == null)) {
      props.changeUsedSearchTerm(false);
      props.changeSearchTerm("");
    } else {
      props.changeUsedSearchTerm(true);
      props.changeSearchTerm(event.target.value);
    }
  };
  const locationDropdown = () => {
    if ((props.needsLocation === "Yes") & props.show_locations) {
      return <LocationDropdown />;
    }
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const getCorrectLogo = () => {
    if (props.logo == undefined) {
      return props.identifyInfo.logo;
    } else {
      return props.logo;
    }
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={{
        style: {
          width: 350,
        },
      }}
    >
      <MenuItem onClick={handleMenuClose}>{locationDropdown()}</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>{locationDropdown()}</MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" elevation={0}>
        <Toolbar>
          <Link to="/" style={{ textDecoration: "none" }}>
            <Box
              component="img"
              sx={{
                height: "100%",
                width: 50,
                maxHeight: { xs: 233, md: 167 },
                maxWidth: { xs: 350, md: 250 },
                marginRight: 2,
              }}
              alt="The house from the offer."
              src={getCorrectLogo()}
            />
          </Link>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" } }}
          >
            {whichTitle()}
          </Typography>
          {props.showSearch ? (
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Zoeken…"
                inputProps={{ "aria-label": "search" }}
                onChange={(event) => handleChange(event)}
              />
            </Search>
          ) : (
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ display: { xs: "block", sm: "none" } }}
            >
              {whichTitle()}
            </Typography>
          )}
          <Box sx={{ flexGrow: 1 }} />
          {props.show_locations && props.needsLocation ? (
            <Box sx={{ display: { xs: "flex", md: "flex" } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <EditLocationAltIcon />
              </IconButton>
            </Box>
          ) : null}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {/* {renderMenu} */}
    </Box>
  );
}

function mapStateToProps(state) {
  return {
    businessLogin: state.login.data.business,
    farmerLogin: state.login.data.farmers,
    logo: state.login.data.logo,
    identifyInfo: state.identify.identifyInfo,
    show_locations: state.login.data.show_locations,
  };
}

export default connect(mapStateToProps, {
  changeUsedSearchTerm,
  changeSearchTerm,
})(Header);
